export default {
  defaultAvatar: 'obs_788803316800001604656483$prod-public-res',
  noDataImg: 'https://obs.prod.ubanquan.cn/obs_041103664200001691394190_pre$prod-ubq',
  noDataImg2: 'https://obs.prod.ubanquan.cn/obs_382703595600001680837760_pre$prod-ubq',
  // synthesisNoDataImg: require('assets/img/common/zhanwushuju@3x.png'),
  noDataText: '暂无数据',
  errorText: '加载异常，请下拉刷新或稍后重试',
  videoDefaultImg: 'https://obs.prod.ubanquan.cn/obs_041103664200001691456744_pre$prod-ubq'
};